// @flow

import React from 'react';
import './ResultCell.scss';

type Props = {
  label: string,
  content: ?string
}

const ResultCell = ({ label, content = '--' }: Props) => (
  <div className="result-cell">
    <div className="result-cell-wrapper">
      <div className="result-cell-content">
        {content}
      </div>
      <div className="result-cell-title">{label}</div>
    </div>
  </div>
);

export default ResultCell;
